import { ApiProperty } from "@nestjs/swagger";
import { IsNotEmpty } from "class-validator";

export class PalletsDtoActive{
    @ApiProperty()
    palletId:number;

    @ApiProperty()
    versionFlag: number;

    @ApiProperty()
    isActive : boolean;

    @ApiProperty()
    updatedUser : string;



}